export default __webpack_public_path__ + "static/media/MALINGA MUGANZA vice presidente .2457fa71.jpg";